module.exports = __webpack_public_path__ + "static/media/lifetales-logo.8d86cad0.svg";